/* ============================================================
   Vídeo no hover do product card.
   - Delegado no document: funciona para cards carregados
     dinamicamente (swipers, ajax de coleção, quickview...).
   - Desktop-only: no mobile (sem hover) o vídeo nem roda;
     fica a foto estática.
   - O <video> usa preload="none": só baixa ao tocar (1º hover).
   ============================================================ */
(function () {
  if (!window.matchMedia ||
      !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  function cardVideo(card) {
    if (card && card.querySelector('.second-image')) return null;
    return card ? card.querySelector('.product-card__video') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest ? e.target.closest('.product-card') : null;
    if (!card || card._azVideoHovering) return;
    card._azVideoHovering = true;
    var v = cardVideo(card);
    if (v) {
      var playing = v.play();
      if (playing && playing.catch) playing.catch(function () {});
    }
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest ? e.target.closest('.product-card') : null;
    if (!card) return;
    // ainda dentro do mesmo card? então não é saída de verdade
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    card._azVideoHovering = false;
    var v = cardVideo(card);
    if (v) v.pause();
  });
})();
